import React from 'react'
import '../Style/Home.css'


function Home() {
  return (
    <div className="home-container">
      
      <div className="text-main">
        <h3>Take Control of your Finances</h3>
        <br/>
        <div> Inflation <strong>raises prices </strong>and <strong> lowers </strong> your purchashing power.Managing your budget involves creating a plan to allocate your income towards your expenses and financial goals. By managing your finances, you can take control of your money and make informed decisions about how to allocate your income towards your expenses, savings, and financial goals.
         </div>
        </div>
      <div className="picture-main">
          <img src="./7849.jpg" id="main-page-img" alt=".."/>

      </div>

      <div className='filler'></div>

    </div>

  )
}



export default Home